import QuoteForm from './Quote'
import QuickQouteStateForm from './QuickQouteStateForm'
import CommonChange from './cabinets/change/CommonChange'
import DayStatsPanel from './cabinets/panels/DayStatsPanel'
import NumbersPanel from './cabinets/panels/NumbersPanel'
import EmailPanel from './cabinets/panels/EmailPanel'
import EmailChange from './cabinets/change/EmailChange'
import PasswordPanel from './cabinets/panels/PasswordPanel'
import PasswordChange from './cabinets/change/PasswordChange'
import LoginCabinet from './cabinets/LoginCabinet'
import ResetCabinet from './cabinets/ResetCabinet'
import RestoreCabinet from './cabinets/RestoreCabinet'
import SendMessageCabinet from './cabinets/SendMessageCabinet'

Vue.component('QuoteForm', QuoteForm)
Vue.component(QuickQouteStateForm.name, QuickQouteStateForm)
Vue.component(CommonChange.name, CommonChange)
Vue.component(DayStatsPanel.name, DayStatsPanel)
Vue.component(NumbersPanel.name, NumbersPanel)
Vue.component(EmailPanel.name, EmailPanel)
Vue.component(EmailChange.name, EmailChange)
Vue.component(PasswordPanel.name, PasswordPanel)
Vue.component(PasswordChange.name, PasswordChange)
Vue.component(LoginCabinet.name, LoginCabinet)
Vue.component(ResetCabinet.name, ResetCabinet)
Vue.component(RestoreCabinet.name, RestoreCabinet)
Vue.component(SendMessageCabinet.name, SendMessageCabinet)



// WEBPACK FOOTER //
// ./src/js/components/Forms/index.js